module.exports = __webpack_public_path__ + "img/forward.b59d9789.svg";